namespace $.$$ {
	export class $shm_hitalama_map_widget_float_settings extends $.$shm_hitalama_map_widget_float_settings {

		private code_save_active = false
		private code_save_revision = 0
		private code_save_requested = ''
		markdown_images_enabled() { return this.controlled_widget().type() === 'text_md' && this.controlled_widget().can_change() }

		controlled_settings_content() {
			const link = this.controlled_widget().link()
			return this.Map_page().Widget(link).Sub().settings_content()
		}

		controlled_type_name() {
			const type = this.controlled_widget().type()
			const title = $shm_hitalama_map_widget_def_titles[type] ?? type
			return title
		}

		controlled_title(): string {
			const w = this.controlled_widget()
			const title = w.title() === w.link_str()
				? this.controlled_type_name()
				: w.title()
			
			return title
		}

		controlled_copy_id() {
			return this.controlled_widget().link_str()
		}
		
		@ $mol_mem
		text( next?: string ): string {
			return this.controlled_widget().text( next ) ?? ''
		}
		
		@ $mol_mem
		code_draft( next?: string | null ): string | null {
			return next ?? null
		}

		@ $mol_mem
		code( next?: string ): string {
			const draft = this.code_draft()
			if( next === undefined ) return draft ?? this.controlled_widget().code() ?? ''

			const current = draft ?? this.controlled_widget().code() ?? ''
			const may_use_file = Math.max( current.length, next.length ) >= $shm_hitalama_file_text_inline_limit / 4
			if( !may_use_file ) return this.controlled_widget().code( next ) ?? ''

			this.code_draft( next )
			this.code_save_request( next )
			return next
		}

		@ $mol_action
		code_save_request( next: string ) {
			this.code_save_requested = next
			++ this.code_save_revision
			if( this.code_save_active ) return
			this.code_save_start()
		}

		private code_save_start() {
			const revision = this.code_save_revision
			const value = this.code_save_requested
			this.code_save_active = true

			$mol_wire_async( this.controlled_widget() ).code( value ).then(
				()=> this.code_save_done( revision ),
				error => this.code_save_failed( revision, error ),
			)
		}

		@ $mol_action
		private code_save_done( revision: number ) {
			if( revision !== this.code_save_revision ) {
				this.code_save_start()
				return
			}

			this.code_save_active = false
			this.code_draft( null )
		}

		@ $mol_action
		private code_save_failed( revision: number, error: unknown ) {
			if( revision !== this.code_save_revision ) {
				this.code_save_start()
				return
			}

			this.code_save_active = false
			$mol_fail_log( error )
		}

		controlled_title_click() {
			this.Map_page().go_to_widget( this.controlled_widget().link() )
		}

	}

}
